export const environment = {
  production: true,
  url: 'https://mueblesapi.altaris.com.mx/api/',
  imagenPerfil: 'assets/images/auth/default-avatar.svg',
  sinFoto: 'assets/images/auth/default-avatar.svg',
  GOOGLE_CLIENT_ID: '1003318322169-lmv53cq3557ghigimijfvsn93575qtsu.apps.googleusercontent.com'
};

